import Button from "../UI/Button";
import { useModal } from "../../hooks/use-modal.jsx";
import MaintenanceLogForm from "./MaintenanceLogForm";
import useMaintenanceLogs from "../../hooks/use-maintenance-logs";
import { useMemo, useState } from "react";
import MaintenanceLogCard from "./MaintenanceLogCard";
import styles from "./MaintenanceLogShow.module.css";
import Card from "../UI/Card.jsx";
import ToggleSwitch from "../UI/ToggleSwitch";
import {
  BalanceDomain,
  DOMAIN_TO_PARENT_ID_FIELD_NAME,
} from "../../utils/constants/balances.js";
import IsLoading from "../UI/IsLoading.jsx";

export default function MaintenanceLogShow({ domain, parentId }) {
  const [
    MaintenanceLogModal,
    closeMaintenanceLogModal,
    openMaintenanceLogModal,
  ] = useModal(false);
  const [maintenanceLogToEdit, setMaintenanceLogToEdit] = useState(null);
  const [showPropertyLogs, setShowPropertyLogs] = useState(true);
  const {
    maintenanceLogs,
    isLoading,
    createMaintenanceLog,
    updateMaintenanceLog,
    deleteMaintenanceLog,
  } = useMaintenanceLogs(domain, parentId);

  const filteredLogs = useMemo(() => {
    if (domain === BalanceDomain.PROPERTY || showPropertyLogs) {
      return maintenanceLogs;
    }
    return maintenanceLogs.filter((log) => log.id_property_folder === parentId);
  }, [domain, maintenanceLogs, parentId, showPropertyLogs]);

  async function submitMaintenanceLogHandler(edit, values) {
    if (edit) {
      await updateMaintenanceLog(
        maintenanceLogToEdit.id,
        values,
        maintenanceLogToEdit.domaine,
        maintenanceLogToEdit[
          DOMAIN_TO_PARENT_ID_FIELD_NAME[maintenanceLogToEdit.domaine]
        ],
      );
    } else {
      await createMaintenanceLog(values, domain, parentId);
    }
    setMaintenanceLogToEdit(null);
    closeMaintenanceLogModal();
  }

  async function deleteHandler(maintenanceLog) {
    await deleteMaintenanceLog(
      maintenanceLog.id,
      maintenanceLog.domaine,
      maintenanceLog[DOMAIN_TO_PARENT_ID_FIELD_NAME[maintenanceLog.domaine]],
    );
    closeMaintenanceLogModal();
  }

  if (isLoading) return <IsLoading />;

  return (
    <>
      <MaintenanceLogModal onClose={() => setMaintenanceLogToEdit(null)}>
        <MaintenanceLogForm
          maintenanceLog={maintenanceLogToEdit}
          onSubmit={(values) =>
            submitMaintenanceLogHandler(!!maintenanceLogToEdit, values)
          }
          onDelete={() => deleteHandler(maintenanceLogToEdit)}
        />
      </MaintenanceLogModal>
      <Card className={"flex space-between"}>
        {domain === BalanceDomain.FOLDER && (
          <div className={"flex align-items-center gap10"}>
            <span>Afficher les articles des biens</span>
            <ToggleSwitch
              status={showPropertyLogs}
              onToggle={() => setShowPropertyLogs(!showPropertyLogs)}
              hasApiCall={false}
            />
          </div>
        )}
        <Button type="button" onClick={openMaintenanceLogModal}>
          Ajouter un article
        </Button>
      </Card>
      <div className={styles.grid}>
        {filteredLogs?.map((maintenanceLog) => (
          <MaintenanceLogCard
            key={maintenanceLog.id}
            maintenanceLog={maintenanceLog}
            onEdit={(log) => {
              setMaintenanceLogToEdit(log);
              openMaintenanceLogModal();
            }}
            onDelete={() => deleteHandler(maintenanceLog)}
          />
        ))}
      </div>
    </>
  );
}
